import React, { useState } from 'react';
import { Text } from '@perch-labs/shrike';
import { copyFor } from 'config';
import { Container } from 'styles';
import { NotificationCard } from '../notification-card';
import { Button } from './carousel.style';

const getCopy = copyFor('dashboard.standardDashboard.notifications.carousel');
interface Props {
  notifications: QueriedNotification[];
  isSMB: boolean;
}

export const Carousel = ({ notifications, isSMB }: Props) => {
  const [index, setIndex] = useState(0);
  const length = notifications.length;

  return (
    <>
      <NotificationCard
        notification={notifications[index]}
        margin={{ bottom: '2px' }}
        isSMB={isSMB}
      />
      <Container
        flex
        alignItems="center"
        width="100%"
        justifyContent="center"
        margin={{ bottom: '24px' }}
      >
        <Button
          icon="ChevronLeft"
          aria-label={getCopy('buttons.previous')}
          disabled={index === 0}
          onClick={() => setIndex(index - 1)}
        />
        <Text>{getCopy('buttons.inner', { index: index + 1, length })}</Text>
        <Button
          icon="ChevronRight"
          aria-label={getCopy('buttons.next')}
          disabled={index === length - 1}
          onClick={() => setIndex(index + 1)}
        />
      </Container>
    </>
  );
};
